export const PORTFOLIO_ENDPOINTS = {
  OVERVIEW: '/api/portfolio/overview',
  RENTAL_INCOME_SUMMARY: '/api/portfolio/rental-income-summary',
  GRAPH: '/api/portfolio/graph',
  HOLDINGS: '/api/portfolio/holdings',
  HOLDINGS_SUMMARY: '/api/portfolio/holdings/summary',
  HOLDING_DETAIL: '/api/portfolio/holdings/{propertyId}',
} as const
